import $ from 'jquery';

var Submenu = {
    selectors: {
        has_subnav_list: $('.has-subnav-list'),
        products_menu_dropdown_toggle: $('.products-menu-dropdown-toggle'),
        products_menu_dropdown: $('.products-menu-dropdown'),
        search_results_dropdown: $('.search-results-dropdown'),
        search_input: $('#search')
    },

    init: function () {
        this.categoriesSubNavHandler();
        this.submenuVisibalityHandler();
        //this.searchResultsHandler();
    },

    submenuVisibalityHandler: function () {
        var selectors = this.selectors;

        $('.products-menu-dropdown-toggle, .products-menu-dropdown').hover(function () {
            selectors.products_menu_dropdown.removeClass('d-none');
            if (!selectors.search_results_dropdown.hasClass('d-none')) {
                selectors.search_results_dropdown.addClass('d-none');
                selectors.search_input.blur();
            }
        }, function () {
            selectors.products_menu_dropdown.addClass('d-none');
        });
    },

    /*searchResultsHandler: function () {
        var selectors = this.selectors;

        $('body').on('input focus', '#search', function() {
            var value = $(this).val();

            if (value.length > 2) {
                selectors.search_results_dropdown.removeClass('d-none');
            } else {
                selectors.search_results_dropdown.addClass('d-none');
            }
        }).on('focusout', function (){
            $(this).val('');
            selectors.search_results_dropdown.addClass('d-none');
        })
    },*/

    categoriesSubNavHandler: function () {
        var selectors = this.selectors;

        $('ul.categories-nav-list__sub-list').each(function() {
            $(this).addClass('d-none');
        });

        selectors.has_subnav_list.hover(function () {
            if ($('> ul.categories-nav-list__sub-list', this).length > 0) {
                $('> ul.categories-nav-list__sub-list', this).removeClass('d-none');
            }
        }, function () {
            if ($('> ul.categories-nav-list__sub-list', this).length > 0) {
                $('> ul.categories-nav-list__sub-list', this).addClass('d-none');
            }
        });
    }
}

export default Submenu;
